export default __webpack_public_path__ + "static/media/disabled_success_sync.c170bb3c.svg";